(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["fe-opportunity-h5"] = factory();
	else
		root["fe-opportunity-h5"] = factory();
})(window, function() {
return 